/* =====================================================
   Plant Diaper Tabs — plant-diaper-tabs.js
   Upload to: Assets folder in your Shopify theme
   ===================================================== */

document.querySelectorAll('.pd-tabs-section').forEach(function (section) {
  var btns   = section.querySelectorAll('.pd-tab-btn');
  var images = section.querySelectorAll('.pd-tab-image');

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.dataset.tabBtn;

      // Reset all buttons
      btns.forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-selected', 'false');
      });

      // Reset all images
      images.forEach(function (img) {
        img.classList.remove('is-active');
      });

      // Activate clicked button
      btn.classList.add('is-active');
      btn.setAttribute('aria-selected', 'true');

      // Activate matching image
      var activeImage = section.querySelector('[data-tab-image="' + target + '"]');
      if (activeImage) activeImage.classList.add('is-active');
    });
  });
});
